// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"e407ac783b149022267a","263":"8410d21839679336b455","791":"f532d88b76d4b4a6aadd"}[chunkId] + ".js";
};